import { formatInt } from "@softmax/product-ux/play-values";
import { SideBlock, SidebarRows } from "@softmax/product-ux/catalog";
import { formatRelative } from "../../play/state";
import type { PreviewContent } from "../content/preview-content.types";
import { LockedRegion } from "../../store-editor";
export function RecentRoundsBlock({
  content,
  now = content.generatedAt,
}: {
  content: PreviewContent;
  now?: string;
}) {
  const rounds = (content.ladder?.recentRounds ?? [])
    .filter(
      (
        round,
      ): round is typeof round & {
        completedAt: string;
      } => round.completedAt !== null,
    )
    .toSorted((a, b) => b.round - a.round)
    .slice(0, 5);

  if (rounds.length === 0) return null;

  return (
    <LockedRegion label="Live data, updated automatically">
      <SideBlock title="Recent rounds" subtitle={content.leagueName}>
        <SidebarRows
          rows={rounds.map((round) => ({
            key: String(round.round),
            left: `Round ${formatInt(round.round)}`,
            right: formatRelative({
              iso: round.completedAt,
              now,
              timeZone: "UTC",
            }),
          }))}
        />
      </SideBlock>
    </LockedRegion>
  );
}
